import { type GQLComponentGroupParentGenericFragment } from "@src/graphql.generated";

export enum ComponentGroupOverviewCategoryTabs {
    Engine = "engine",
    Frame = "frame",
    WPParts = "wpParts",
}

/**
 * This utility function is used for filtering an existing list of componentGroups. Each componentGroup holds a list of componentSubgroups.
 * The functions returns the filtered list. If a component group matching the search term is found within a parent group,
 * the entire entry is returned (this may also contain non-matching results).
 *
 * @param list: ComponentGroupArray
 * @param searchTerm: string
 * @returns ComponentGroupArray
 */
export const filterComponentGroupArrayBySearchTerm = (
    list: GQLComponentGroupParentGenericFragment[],
    searchTerm: string,
): GQLComponentGroupParentGenericFragment[] => {
    if (!searchTerm) {
        return list;
    }

    return list.filter((componentGroupParent) => {
        const subGroupMatch = componentGroupParent.componentSubGroups.some((subGroup) => {
            return (
                subGroup.componentGroup.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
                subGroup.componentGroup.description.toLowerCase().includes(searchTerm.toLowerCase())
            );
        });

        const groupMatch = componentGroupParent.componentGroup.code.toLowerCase().includes(searchTerm.toLowerCase());

        return subGroupMatch || groupMatch;
    });
};
